import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import {
  CreateIp,
  DeleteIP,
  GetIPList,
} from "src/DAL/IpPermissions/IpPermissions";

export const IpPermission = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [ipInputs, setIpInputs] = useState([""]);
  const [ipList, setIpList] = useState([]);
  const [selectedIp, setSelectedIp] = useState("");
  const [open, setOpen] = useState(false);

  // Add new input field
  const handleAddMore = () => {
    setIpInputs([...ipInputs, ""]);
  };

  // Remove single dynamic input field before submitting
  const handleRemoveInput = (index) => {
    if (ipInputs.length === 1) {
      setIpInputs([""]); // Keep at least one empty input
    } else {
      const updatedInputs = ipInputs.filter((_, i) => i !== index);
      setIpInputs(updatedInputs);
    }
  };

  // Update input value
  const handleInputChange = (index, value) => {
    const updatedInputs = [...ipInputs];
    updatedInputs[index] = value;
    setIpInputs(updatedInputs);
  };

  const handleRadioChange = (ip) => {
    setSelectedIp(ip);
    setOpen(true);
  };

  // Delete selected IP permission (Radio Selection Delete)
  const handleDelete = async () => {
    if (!selectedIp) return;
    await executeDelete(selectedIp);
  };

  // Delete specific saved IP directly from list row
  const handleDirectDelete = async (ipToDelete) => {
    await executeDelete(ipToDelete);
  };

  const executeDelete = async (ip) => {
    const payload = { ip };
    const resp = await DeleteIP(payload);
    if (resp?.status === true) {
      enqueueSnackbar(resp?.message || "IP removed successfully", { variant: "success" });
      if (selectedIp === ip) {
        setSelectedIp("");
        setOpen(false);
      }
      fetchData();
    } else {
      enqueueSnackbar(resp?.message || "Failed to remove IP", { variant: "error" });
    }
  };

  const handleSubmit = async () => {
    const validIps = ipInputs.map((ip) => ip.trim()).filter((ip) => ip !== "");

    if (validIps.length === 0) {
      enqueueSnackbar("Please enter at least one valid IP address.", { variant: "warning" });
      return;
    }

    const payload = {
      login_ip_whitelist: validIps,
    };
    const resp = await CreateIp(payload);
    if (resp?.status === true) {
      enqueueSnackbar(resp?.message || "IP permissions updated successfully", { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(resp?.message || "Failed to submit IP permissions", { variant: "error" });
    }
  };

  const fetchData = async () => {
    const resp = await GetIPList();
    if (resp?.status === true) {
      const ips = resp?.data?.login_ip_whitelist || [];
      setIpList(ips);
      if (ips.length > 0) {
        setIpInputs(ips);
      } else {
        setIpInputs([""]);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "30px auto",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "10px",
      }}
    >
      <h5 style={{ color: "white", fontWeight: 600 }}>IP Permission</h5>

      {/* Dynamic Input Fields */}
      {ipInputs.map((ip, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            placeholder="Enter IP Address"
            value={ip}
            onChange={(e) => handleInputChange(index, e.target.value)}
            style={{
              flex: 1,
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              backgroundColor: "transparent",
              color: "white",
            }}
          />

          {/* Remove Row Button */}
          {index > 0 && (
            <button
              onClick={() => handleRemoveInput(index)}
              title="Remove field"
              style={{
                padding: "10px 14px",
                background: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Remove
            </button>
          )}

          {/* Add More Button */}
          {index === ipInputs.length - 1 && (
            <button
              onClick={handleAddMore}
              style={{
                padding: "10px 15px",
                background: "#4F3B98",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              Add More
            </button>
          )}
        </div>
      ))}

      {/* Submit Button */}
      <button
        onClick={handleSubmit}
        style={{
          marginTop: "10px",
          padding: "10px 20px",
          background: "#4F3B98",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        Submit
      </button>

      {/* Delete Radio-Selected IP Button */}
      {open && (
        <button
          onClick={handleDelete}
          style={{
            marginLeft: "10px",
            padding: "10px 20px",
            background: "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Delete Selected
        </button>
      )}

      {/* IP List */}
      {ipList.length > 0 && (
        <div style={{ marginTop: "30px" }}>
          <h3 style={{ color: "white" }}>Saved IP Addresses</h3>

          {ipList.map((ip, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "8px 0",
                borderBottom: "1px solid #333",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <input
                  type="radio"
                  name="selectedIp"
                  checked={selectedIp === ip}
                  onChange={() => handleRadioChange(ip)}
                />
                <span style={{ color: "white" }}>{ip}</span>
              </div>

              {/* Direct Remove Action */}

              <button
                onClick={() => handleDirectDelete(ip)}
                style={{
                  padding: "5px 10px",
                  background: "transparent",
                  color: "#dc3545",
                  border: "1px solid #dc3545",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                Remove Permission
              </button>

            </div>
          ))}
        </div>
      )}
    </div>
  );
};